<template>
  <b-container>
    <b-row v-if="!$store.state.authorized">
      <b-col md="6" offset-md="3">
        <h3 class="mb-4">Soundslides Group License Manager</h3>
        <p>
          Welcome to the group manager for Soundslides multi-user licenses.
        </p>
        <p>With this site, you can add and remove users on your license.</p>
        <p>
          Please log in with your Soundslides account information.
        </p>
        <Login />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <p>Welcome, {{ $store.state.user.email }}.</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/Login.vue";

export default {
  name: "Home",
  components: {
    Login
  }
};
</script>
